// routeConstants.js
'use strict';

export const globalAllowedSearchParams = [
  'campaign',
  'campaign-id',
  'region',
  'action',
  'act',
  'login-email',
  'email',
  'order',
  'p_id',
  'si',
  'ti',
  'st',
  'sd',
  'type',
];

export const allowedSearchParams = {
  '/': ['feed', 'filters', 'filters_v2', 'sorting', 'sorts'],
  '/livestream': ['feed', 'filters', 'filters_v2', 'sorting', 'sorts'],
  '/search/all': ['q'],
  '/search/:type': ['q', 'sorting', 'sorts'],
  '/user-following-grid/:category': ['ui'],
  '/user-feed-grid/:feed': [
    'filters',
    'filters_v2',
    'sorting',
    'sorts',
    'ssr',
    'ui',
  ],
  '/flix-categories/:category': [
    'filters',
    'filters_v2',
    'sorting',
    'sorts',
    'ssr',
    'ui',
  ],
  '/story-categories/:category': [
    'filters',
    'filters_v2',
    'sorting',
    'sorts',
    'ssr',
    'ui',
  ],
  '/shorts-categories/:category': [
    'filters',
    'filters_v2',
    'sorting',
    'sorts',
    'ssr',
    'ui',
  ],
  '/hashtag/:hashtag/:type': ['sorting', 'sorts'],
  '/category/:category/:type': ['sorting', 'sorts', 'ssr'],
  '/iframe': ['source', 'title'],
};

export const moreLinkPageParamRoutes = [
  '/flix-categories/:category',
  '/story-categories/:category',
  '/shorts-categories/:category',
];
